export const NAME = 1260822048450;
export const ACCOUNT_NAME = 1900001824264;
export const BILLING_DISPUTE_REASON = 12414308342043;
export const WEBSITE_URL = 1260822291809;
export const BLOCKER_TYPE = 1260819959789;
export const REQUEST_TYPE = 1260819957729;

// mfa reason custom field
export const MFA_REASON = 33101551294619;

// mfa custom fields NOT used
export const COMPANY_TEST_URL = 31778774565531;
export const ORG_MAILING_ADDRESS = 31779335838235;
export const PROFILE_NAMES = 31778924758299;
export const LAST_LOGIN_DATE = 31779056296347;
export const CAMPAIGN_FLOW_NAME = 31779102278427;
export const OTHER_EMAILS = 31779132238875;
export const RECENT_INVOICE = 31778824522139;